// for trip Details page
export const BACK_TO_TRIPS = '← Back to trips'
export const TRIP_ID = 'Trip Id'
export const CLOSE = 'Close'
export const NAME = 'Name'
export const SECTOR = 'Sector'
export const PNR = 'PNR'
export const TICKET = 'Ticket No.'
export const SEAT = 'Seat No.'
export const STATUS = 'Status'
export const BAGGAGE = 'Baggage (per adult/child)'
export const VIEW_DETAILS = 'View details'
export const AIRLINE_SUPPORT = 'Airline support'
export const CLEARTRIP_SUPPORT = 'Cleartrip support'
export const ASSISTANCE_LINE =
  'For quick assistance, please call from the contact number provided in your booking'
export const CABIN = 'Cabin'
export const CHECK_IN = 'Check-in'
export const FARE_RULES = 'Fare rules'
export const CHECK_IN_COUNTER_CLOSE = 'Check-in counter close'
export const TRANSIT_TIME = 'Transit time'
export const CHANGE_PLANES = 'Change Planes'
export const FLIGHT_BOOKED_WITH_FLEXIFLY = 'Flight booked with Flexifly'
export const SAVE_ON_MESSAGE =
  'Save on rescheduling and convenience fees.Refund upto ₹3200 per person, per flight for changes made.'
export const KNOW_MORE = 'Know more'
export const TRAVELLER_DETAILS = 'Traveller Details'
export const CANCEL_FLIGHTS = 'Cancel flights'
export const CANCEL_FLIGHTS_MESSAGE = 'Cancel this trip in 3 easy steps'
export const CALCULATE_REFUND = 'Calculate Refund'
export const CHANGE_FLIGHTS = 'Change flights'
export const CHANGE_FLIGHTS_MESSAGE = 'Reschedule this flight in 4 easy steps'
export const CALCULATE_REFUND_MESSAGE = 'Know refund before you cancel'
export const PAYMENT_DETAILS = 'Payment Details'
export const TOTAL = 'Total'
export const TOTAL_PAID = 'Total paid'
export const CONTACT_DETAILS = 'Contact Details'
export const EMAIL = 'Email'
export const PHONE = 'Phone'
export const PAID_VIA = 'paid via'
export const NON_REFUNDABLE = 'Non Refundable'
export const REFUNDABLE = 'Refundable'
export const TRIP_ID_MISSING = 'Trip ID missing!!'
// export const REFUNDABLE = 'Refundable'
export const SORRY_UNABLE = 'Sorry, unable to get your details right now.'
export const SEEMS_THERE = "Seems there's a temporary issue with our system."
export const TRY_AGAIN = 'Try again'
export const LOADING_TRIP_DETAILS = 'Loading trip details...'
export const LOADING_FAQ = 'Loading FAQs...'
export const LOADING_CONTACT_DETAILS = 'Loading contact details...'

// for trip details support pane
export const CHAT = 'Chat'
export const CONTACT_US = 'Contact us'
export const WELL_HELP = 'We’ll help you out'
export const PRINT_ETICKET = 'Print e-ticket'
export const PRINT_ERECEIPT = 'Print eReceipt'
export const PRINT_PAYMENT_RECEIPT = 'Print payment receipt'
export const PRINT_VOUCHER = 'Print voucher'
export const EMAIL_PASS = 'Email pass'
export const EMAIL_VOUCHER = 'Email voucher'
export const EMAIL_ITINERARY = 'Email itinerary'
export const SMS_TRIP = 'SMS trip details'
export const YOUR_TRAVELL_BOOKINGS = 'Your travel bookings'
export const PRINT_TAX_INVOICE = 'Print tax invoice'

// for Travellers Section
export const TRAVELLERS_HEADER = 'Traveller Details'
export const TRAVELLER = 'Traveller'
export const TRIP_TOOLS_HEADER = 'Trip tools'
export const TRAVELLER_DETAILS_HEADER = 'Traveller Details'

// for payments section
export const PAYMENT_DETAILS_HEADER = 'Payment Details'

// for triplist
export const TRIPS_LOAD_MSG_HEADING = 'Fetching trips'
export const TRIPS_LOAD_MSG_SUBHEADING = 'Please wait while we load your trips.'
export const CANCEL_TRIP_HEADER = 'Cancel'
export const CHECK_REFUND_HEADER = 'Check refund'
export const CHANGE_FLIGHT_HEADER = 'Change flights'
export const ADD_TO_PASSBOOK_HEADER = 'Add to passbook'
export const EMAIL_TRIP_HEADER = 'Email trip'
export const CANCEL_TRIP_SUBHEADING = 'Cancel this trip in 3 easy steps'
export const CHECK_REFUND_SUBHEADING = 'Know your refund before cancellation'
export const CHANGE_FLIGHT_SUBHEADING = 'Change flights in 4 simple steps'
export const ADD_TO_PASSBOOK_SUBHEADING = 'Save the planet. Go Paperless.'
export const EMAIL_TRIP_SUBHEADING = 'Share your trip easily'
export const TRIPS_FETCH_ERROR_MESSAGE =
  'Sorry, unable to fetch your trips right now.'
export const TRIPS_NOT_AVAILABLE_MESSAGE = 'Your bookings appear here'
export const SEE_ALL_BOOKINGS_TEXT = 'See all bookings'
export const LOAD_MORE_TEXT = 'Load More'

// for trip details section
export const TRIPDETAILS_CABIN_BAGGAGE_TITLE = 'Cabin'
export const TRIPDETAILS_CHECKIN_BAGGAGE_TITLE = 'Check-in'
export const TRIPDETAILS_PNR_TITLE = 'PNR'
export const TRIPDETAILS_BAGGAGE_VIEW_DETAILS_TITLE = 'View Details'
export const VENUE_HEADER = 'Venue'
export const BOOKING_DETAILS_HEADER = 'Booking details'
export const BOOKING_INFORMATION_HEADER = 'Booking Information'
export const ORGANISER_DETAILS_HEADER = 'Organiser Details'
export const TRIPDETAILS_HOTEL_ITINERARY_TITLE = 'Booking Details'
export const TRIPDETAILS_VOUCHER_CODE_TITLE = 'Voucher # '
export const TRIPDETAILS_ADDRESS_TITLE = 'ADDRESS'
export const BAGGAGE_PER_PERSON = 'Baggage (per adult/child)'

// Baggage info modal section
export const BAGGAGE_MODAL_TITLE = 'Baggage (per person)'
export const BAGGAGE_MODAL_MESSAGE =
  'Free checkin-baggage allowance is 20 kg per adult & child. If travelling ex-india to Muscat / Colombo / Dubai / Kabul / HonKong / Jeddah, free check-in baggage allowance is 30 kgs. If travelling ex-Muscat / ex-Colobmo / ex-Dubai / ex-Kabul / ex-HongKong free check-in baggage allowance is 30 kg per adult. If travelling ex-Jeddah free check-in baggage allowance is 30kgs + 5LT. Each bag must not exceed 32 kg and overall dimensions of checked baggage should not exceed 62 inches.'
export const BAGGAGE_PRIMARY_BUTTON_TITLE = 'Got it'

// Email trip modal texts
export const SEND_TEXT = 'Send'
export const CANCEL_TEXT = 'Cancel'
export const EMAIL_INPUT_LABEL = 'Please enter email id'
export const EMAIL_SUCCESS_MESSAGE = 'Email sent successfully'
export const EMAIL_ERROR_MESSAGE =
  'Email cannot be sent currently. Please try in some time'
export const EMAIL_VALIDATION_ERROR = 'Email Address is not valid'

export const TERMINAL_LABEL = 'Terminal'

export const TRIP_NOT_FOUND_MSG =
  'The details for the trip cannot be fetched at the moment. Please call our customer care for any information.'
export const REFUND_BREAKUP_NOTE =
  '**Convenience fee of 0.0 per passenger paid during booking is non-refundable as it is used towards "Payment Gateway" charges. This helps us run Cleartrip.'
export const EMAIL_ETICKET = 'Email e-ticket'
export const EMAIL_INVOICE = 'Email GST Invoice'

// Switch for ROR downlaod e-ticket
export const ROR_DOWNLOAD_E_TICKET_SWITCH = false
